/* eslint no-extend-native: ["error", { "exceptions": ["Number"] }] */
Number.prototype.toMoneyString = function() {
  const { accounting } = window;
  const currency = `${window.localStorage.getItem('currency')}$`;
  if (!accounting) return this;
  return accounting.formatMoney(this, currency);
};

const getDateValuesFromTimestamp = timestamp => {
  const date = new Date(timestamp);
  return [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  ];
};
Number.prototype.timestampToDateString = function() {
  const [year, month, day] = getDateValuesFromTimestamp(this);
  return `${day}/${month}/${year}`;
};
Number.prototype.timestampToISODateString = function() {
  const [year, month, day] = getDateValuesFromTimestamp(this);
  const theMonth = month.toString().length === 1 ? `0${month}` : month;
  const theDay = day.toString().length === 1 ? `0${day}` : day;
  return `${year}-${theMonth}-${theDay}`;
};



// WEBPACK FOOTER //
// ./src/utils/extensions/NumberExtension.js